import React, {Button, Component, useState } from "react";
import PageTitle from "../../components/PageTitle/PageTitle";
import Cookies from 'universal-cookie';
import LoadingOverlay from 'react-loading-overlay';
import _ from '../../utils/languages/languages';
import GetUsersService from '../../services/getUsers';
import deleteUser from '../../services/deleteUser';
import UsersTable from '../../widgets/tables/UsersTable';

export default class UsersList extends React.Component {

  constructor(props){
    super (props)
  
    this.pageDiv = {
      border: '1px solid #cccccc',
      padding: 10
    };
  
    this.section = this.props.section
    if (this.section == undefined){
      const pathname = props.location.pathname;
      this.section = pathname.substring(8, pathname.length);
    }

    this.pageTitle = props.pageTitle;
    this.pageName = props.pageName;
    if (this.pageName == undefined){
      this.pageName = this.section;
    }

    this.userslist = [];

    this.state = {
      testo: '',
      menuBackground: '#ffffff',
      menuItemColor: '#000000',
      fontSize: 50,
      fontBold: false,
      logoPicture: '',
      logoMargin: 0,
      titleColor: '#000000',
      titleSize: 18,
      isLoading: false,
      addElementVisible: false
    }

    this.grid = 2;

    this.pageTitle = "Users list";

    this.state = {

    };

  }

  async update(){

    const cookies = new Cookies();
    const username = cookies.get('username', { path: '/' });
    const token = cookies.get('token', { path: '/' });
    this.userslist = await GetUsersService(username, token);

    this.setState({});
  }


  async componentDidMount(){

    this.update();
  }

  render () {

    const defaultFontValue = {
      fontFamily: 'Montserrat',
      fontSize: 21,
      color: '#555555'
    }

    var headCells = [
      { id: 'username', numeric: false, disablePadding: true, label: 'Username' },
      { id: 'name', numeric: true, disablePadding: false, label: 'Name' },
      { id: 'surname', numeric: true, disablePadding: false, label: 'Surname' },
      { id: '', numeric: true, disablePadding: false, label: '' },
    ];

    function createData(username, name, surname, id) {
      return { username, name, surname, id };
    }

    var rows = [];
    this.userslist.length > 0 && this.userslist.map((v, k) => {
      rows.push(createData(v.username, v.name, v.surname, v.id));
    });

    return (
      <>
      <LoadingOverlay
      active={this.state.isLoading}
      styles={{
        content: (base) => ({
          position: 'relative',
          width: '100%',
          top: '200px'
        })
      }}
      spinner
      text={_.tr('Loading your content...')}
      >
        <PageTitle title={this.pageTitle} />
          <UsersTable headCells={headCells} rows={rows} onDelete={async (id) => {
          if (window.confirm("Delete the user?")) {
              const cookies = new Cookies();
              const username = cookies.get('username', { path: '/' });
              const token = cookies.get('token', { path: '/' });
              await deleteUser(username, token, id);
              this.update();
            }
          }}/>

        </LoadingOverlay>
      </>
    );
  }

}

